window.PedidoFornecedor = Backbone.Model.extend({

});

const PedidosFornecedores = Backbone.Collection.extend({
    model: PedidoFornecedor
});
 
window.PedidosFornecedores = PedidosFornecedores


export {
    PedidosFornecedores
}